import { render, staticRenderFns } from "./IndexReportRate.vue?vue&type=template&id=a133b392&scoped=true&"
import script from "./IndexReportRate.vue?vue&type=script&lang=js&"
export * from "./IndexReportRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a133b392",
  null
  
)

export default component.exports